// extracted by mini-css-extract-plugin
export default {"todoicons":"todoicon_todoicons__+UUgp","icons":"todoicon_icons__8zWQ7","todostyling":"todoicon_todostyling__qfrxU"};